import React from 'react';
import {Box} from '@mui/material';
import {Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './Buttons.module.scss';

type ContactSalesButtonProps = {onContactSalesClick: () => void};

export function ContactSalesButton({
  onContactSalesClick,
}: ContactSalesButtonProps) {
  return (
    <Button
      appearance="brand"
      mode="filled"
      size="medium"
      onClick={onContactSalesClick}
      className={styles.ctaButton}
    >
      {translate(`Contact Sales`)}
    </Button>
  );
}

type PricingCtaButtonProps = {
  isDisabled: boolean;
  isHighlighted?: boolean;
  isCurrentPlan?: boolean;
  text: string;
  isLoading?: boolean;
  onClick?: () => void;
};

export function PricingCtaButton({
  isDisabled,
  isHighlighted = true,
  isCurrentPlan = false,
  isLoading = false,
  onClick,
  text,
}: PricingCtaButtonProps) {
  const loadingIcon = '/assets/svg/icon-loading-circle-white.svg';
  let className = styles.ctaButton;
  if (isDisabled) {
    className = styles.isDisabled;
  } else if (isHighlighted) {
    className = styles.highlightedCtaButton;
  }

  return (
    <Button
      appearance="brand"
      mode="filled"
      size="medium"
      onClick={isLoading ? () => {} : onClick}
      disabled={isLoading || isDisabled || isCurrentPlan}
      className={className}
    >
      {isLoading ? (
        <Box
          component="img"
          src={loadingIcon}
          alt="loading circle icon"
          sx={{pr: '4px'}}
        />
      ) : (
        text
      )}
    </Button>
  );
}
